import get from 'lodash/get';
import { fetchBracketView } from '../service/bracket-view';
import { loading } from '@actions';

// Carga las 3 capas del bracket (real/original/effective) para un usuario.
// Cachea por userId: si ya tenemos los datos de ese mismo usuario, no refetch.
export const loadBracketView = (userId) => async (dispatch, getState) => {
  const state = getState();
  const token = state.jwToken;
  const targetUserId = userId || get(state, 'user._id');

  if (!token || !targetUserId) {
    return null;
  }

  const current = state.bracketView;
  if (current && String(current.userId) === String(targetUserId)) {
    return current;
  }

  dispatch(loading(true));
  try {
    const res = await fetchBracketView(token, targetUserId);
    const payload = { userId: targetUserId, ...res.data };
    dispatch({ type: 'BRACKET_VIEW_SET', payload });
    return payload;
  } finally {
    dispatch(loading(false));
  }
};
